import React from 'react';
import './styles/Radio.scss';

export const Radio = ( props ) => {
  const { onChange, checked, id, name, value, required, className, innerRef } = props;
  const inputProps = { onChange, checked, id, required, name, value };
  // toggle on pressing enter
  const ref = React.createRef();
  // let the parent reach the input as well ( used for setCustomValidity )
  const setRef = node => {
    ref.current = node;
    if ( typeof innerRef === 'function' ) innerRef( node );
    else if ( innerRef ) innerRef.current = node;
  }
  const onKeyPress = ( event ) => {
    if ( event.key === 'Enter' ) {
      event.preventDefault(); // do not submit the parent form
      ref.current.click();
    }
  }

  return (
    <label className={`radio ${ className || '' }`} tabIndex={0} onKeyPress={onKeyPress}>
      <input className='form-check-input' type='radio' { ...inputProps } ref={ setRef } />
      <span className='radio-state' />{' '}
      { props.children }
    </label>
  );
}



// WEBPACK FOOTER //
// ./src/components/inputs/Radio.jsx